<div class="ic-container">

  <!-- ═══════════ 頂部標題 ═══════════ -->
  <div class="ic-header">
    <div class="ic-header-icon">☯</div>
    <h1 class="ic-title">易經卜卦</h1>
    <p class="ic-subtitle">以三位數卜算六十四卦，探索命運玄機</p>
  </div>

  <!-- ═══════════ Wizard 步驟進度條 ═══════════ -->
  <div class="ic-stepper">
    @for (step of steps; track $index; let i = $index) {
      <div class="ic-step"
           [class.active]="ic.currentStep === i"
           [class.done]="ic.currentStep > i"
           (click)="goToStep(i)">
        <div class="ic-step-circle">
          @if (ic.currentStep > i) {
            <span class="step-check">✓</span>
          }
          @if (ic.currentStep <= i) {
            <span>{{ i + 1 }}</span>
          }
        </div>
        <div class="ic-step-label">{{ step }}</div>
      </div>
      @if (i < steps.length - 1) {
        <div class="ic-step-line"
             [class.done]="ic.currentStep > i"></div>
      }
    }
  </div>

  <!-- ═══════════ Step 0：基本資料 ═══════════ -->
  @if (ic.currentStep === 0) {
  <div class="ic-step-content">
    <div class="ic-card">
      <div class="ic-card-title">
        <span class="card-icon">📋</span> 基本資料
      </div>
      <div class="ic-form-grid">
        <app-jkedit
          [visible]="true"
          label="姓名"
          [required]="true"
          [(value)]="ic.name"
          class="w-full"
        ></app-jkedit>

        <app-jkdatefield
          labelMode="floating"
          label="日期"
          [(value)]="ic.date1"
          [showClearButton]="true"
          class="w-full"
        ></app-jkdatefield>

        <app-jknumberedit
          [visible]="true"
          label="年齡"
          [required]="true"
          [(value)]="ic.age"
          class="w-full"
        ></app-jknumberedit>

        <app-jkcombobox
          label="性別"
          [required]="true"
          [(value)]="ic.sex"
          [items]="sexList"
          class="w-full"
        ></app-jkcombobox>

        <app-jkcombobox
          label="問題分類"
          [required]="true"
          [(value)]="ic.jcktl005"
          [items]="jcktl005List"
          class="w-full col-span-2"
        ></app-jkcombobox>

        <app-jktextarea
          label="問占內容"
          [rows]="4"
          name="question"
          id="question"
          [required]="true"
          [(value)]="ic.question"
          [autoResizeEnabled]="true"
          [minHeight]="100"
          [maxHeight]="300"
          class="w-full col-span-2"
        ></app-jktextarea>
      </div>

      <!-- 說明參考區塊（可摺疊） -->
      <div class="ic-info-tabs">
        <mat-tab-group class="jk-tab-group ic-ref-tabs">
          <mat-tab label="📖 提問說明">
            <app-markdown
              label="說明"
              name="helpDoc"
              id="helpDoc"
              [markdownContent]="ic.helpDocument"
              class="w-full mt-2"
            ></app-markdown>
          </mat-tab>
          <mat-tab label="📜 六十四卦">
            <app-markdown
              label="六十四卦名"
              name="list64Doc"
              id="list64Doc"
              [markdownContent]="ic.list64Document"
              class="w-full mt-2"
            ></app-markdown>
          </mat-tab>
          <mat-tab label="🗂 對照表">
            <app-markdown
              label="對照表"
              name="hexagramDoc"
              id="hexagramDoc"
              [markdownContent]="ic.hexagramDocument"
              class="w-full mt-2"
            ></app-markdown>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>

    <!-- 底部操作按鈕 -->
    <div class="ic-footer-actions">
      <div></div>
      <button class="ic-btn ic-btn-primary" (click)="nextStep()">
        下一步：取卦方式 →
      </button>
    </div>
  </div>
  }

  <!-- ═══════════ Step 1：取卦方式 ═══════════ -->
  @if (ic.currentStep === 1) {
  <div class="ic-step-content">
    <mat-tab-group class="jk-tab-group ic-method-tabs">

      <!-- 方法一：自動三位數 -->
      <mat-tab>
        <ng-template mat-tab-label>
          🎲 自動產生三位數
        </ng-template>
        <div class="ic-card">
          <div class="ic-card-title">
            <span class="card-icon">🎲</span> 數字占卦法
          </div>
          <p class="ic-method-desc">
            隨意選擇三組三位數（首位不可為零）。以第一組÷8取餘為下卦，第二組÷8取餘為上卦，第三組÷6取餘為變爻。
          </p>

          <div class="ic-number-grid">
            <div class="ic-number-card">
              <div class="number-label">第一個數（下卦）</div>
              <app-jknumberedit
                [visible]="true"
                label="第一個"
                [required]="true"
                [(value)]="ic.n1"
                class="w-full"
              ></app-jknumberedit>
              @if (ic.n1 > 0) {
              <div class="number-hint">
                {{ ic.n1 }} ÷ 8 余 {{ ic.n1 % 8 === 0 ? 8 : ic.n1 % 8 }}
                → {{ ic.getTrigramName(ic.n1 % 8 === 0 ? 8 : ic.n1 % 8) }}
              </div>
              }
            </div>
            <div class="ic-number-card">
              <div class="number-label">第二個數（上卦）</div>
              <app-jknumberedit
                [visible]="true"
                label="第二個"
                [required]="true"
                [(value)]="ic.n2"
                class="w-full"
              ></app-jknumberedit>
              @if (ic.n2 > 0) {
              <div class="number-hint">
                {{ ic.n2 }} ÷ 8 余 {{ ic.n2 % 8 === 0 ? 8 : ic.n2 % 8 }}
                → {{ ic.getTrigramName(ic.n2 % 8 === 0 ? 8 : ic.n2 % 8) }}
              </div>
              }
            </div>
            <div class="ic-number-card">
              <div class="number-label">第三個數（變爻）</div>
              <app-jknumberedit
                [visible]="true"
                label="第三個"
                [required]="true"
                [(value)]="ic.n3"
                class="w-full"
              ></app-jknumberedit>
              @if (ic.n3 > 0) {
              <div class="number-hint">
                {{ ic.n3 }} ÷ 6 余 {{ ic.n3 % 6 === 0 ? 6 : ic.n3 % 6 }}
                → 第 {{ ic.n3 % 6 === 0 ? 6 : ic.n3 % 6 }} 爻
              </div>
              }
            </div>
          </div>

          <div class="ic-action-row">
            <button class="ic-btn ic-btn-accent" (click)="ic.doRandom()">
              🎲 自動產生三個三位數
            </button>
            <button class="ic-btn ic-btn-primary" (click)="doCalculate()">
              ⚡ 計算卦象
            </button>
          </div>
        </div>
      </mat-tab>

      <!-- 方法二：自行輸入 -->
      <mat-tab>
        <ng-template mat-tab-label>
          ✍️ 自行輸入上下卦
        </ng-template>
        <div class="ic-card">
          <div class="ic-card-title">
            <span class="card-icon">✍️</span> 直接選擇卦象
          </div>
          <p class="ic-method-desc">
            直接選擇上卦、下卦及變爻位置，適合已知卦象的情況。
          </p>
          <div class="ic-trigram-grid">
            <app-jkcombobox
              label="上卦"
              [(value)]="ic.upperTrigramIndexStr"
              [items]="ic.trigramMap"
              class="w-full"
            ></app-jkcombobox>
            <app-jkcombobox
              label="下卦"
              [(value)]="ic.lowerTrigramIndexStr"
              [items]="ic.trigramMap"
              class="w-full"
            ></app-jkcombobox>
          </div>
          <app-jknumberedit
            [visible]="true"
            label="變爻（1-6）"
            [required]="true"
            [(value)]="ic.changingLineIndex"
            class="w-full mt-3"
          ></app-jknumberedit>
          <div class="ic-action-row">
            <button class="ic-btn ic-btn-primary" (click)="doManualInput()">
              ⚡ 計算卦象
            </button>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <!-- 底部操作按鈕 -->
    <div class="ic-footer-actions">
      <button class="ic-btn ic-btn-ghost" (click)="prevStep()">
        ← 上一步
      </button>
      <button class="ic-btn ic-btn-primary"
              [disabled]="!ic.calculated"
              (click)="nextStep()">
        查看結果 →
      </button>
    </div>
  </div>
  }

  <!-- ═══════════ Step 2：卦象結果 ═══════════ -->
  @if (ic.currentStep === 2) {
  <div class="ic-step-content">

    <!-- 卦名顯示主卡 -->
    <div class="ic-result-header">
      <div class="ic-hexagram-display">
        <div class="hex-col">
          <div class="hex-type-label">本卦</div>
          <div class="hex-emoji">
            {{ ic.getTrigramEmoji(ic.upperTrigramIndex) }}{{ ic.getTrigramEmoji(ic.lowerTrigramIndex) }}
          </div>
          <div class="hex-name">{{ ic.hexagram }}</div>
          <div class="hex-detail">
            <span class="hex-badge">上：{{ ic.getTrigramEmoji(ic.upperTrigramIndex) }} {{ ic.getTrigramName(ic.upperTrigramIndex) }}</span>
            <span class="hex-badge">下：{{ ic.getTrigramEmoji(ic.lowerTrigramIndex) }} {{ ic.getTrigramName(ic.lowerTrigramIndex) }}</span>
          </div>
        </div>
        <div class="hex-divider">→</div>
        @if (ic.calculated) {
        <div class="hex-col">
          <div class="hex-type-label secondary">互卦</div>
          <div class="hex-emoji secondary">
            {{ ic.getTrigramEmoji(ic.overlappingHexagram[1]) }}{{ ic.getTrigramEmoji(ic.overlappingHexagram[0]) }}
          </div>
          <div class="hex-name">{{ ic.overlappingName }}</div>
          <div class="hex-detail">
            <span class="hex-badge">上：{{ ic.getTrigramEmoji(ic.overlappingHexagram[1]) }} {{ ic.getTrigramName(ic.overlappingHexagram[1]) }}</span>
            <span class="hex-badge">下：{{ ic.getTrigramEmoji(ic.overlappingHexagram[0]) }} {{ ic.getTrigramName(ic.overlappingHexagram[0]) }}</span>
          </div>
        </div>
        <div class="hex-divider">→</div>
        <div class="hex-col">
          <div class="hex-type-label accent">變卦</div>
          <div class="hex-emoji accent">
            {{ ic.getTrigramEmoji(ic.changeHexagram[1]) }}{{ ic.getTrigramEmoji(ic.changeHexagram[0]) }}
          </div>
          <div class="hex-name">{{ ic.changeName }}</div>
          <div class="hex-detail">
            <span class="hex-badge">上：{{ ic.getTrigramEmoji(ic.changeHexagram[1]) }} {{ ic.getTrigramName(ic.changeHexagram[1]) }}</span>
            <span class="hex-badge">下：{{ ic.getTrigramEmoji(ic.changeHexagram[0]) }} {{ ic.getTrigramName(ic.changeHexagram[0]) }}</span>
          </div>
        </div>
        }
      </div>
      <div class="hex-changing-line">
        <span class="changing-badge">變爻第 {{ ic.changingLineIndex }} 爻</span>
      </div>
    </div>

    <!-- AI 解卦 + 周易說明 -->
    <div class="ic-card">
      <div class="ic-card-title">
        <span class="card-icon">🤖</span> AI 解卦
        <div class="doc-kind-selector">
          <app-jkcombobox
            label="查看說明"
            [(value)]="ic.documentKind"
            [items]="ic.documentKindList"
            class="doc-select"
          ></app-jkcombobox>
        </div>
      </div>

      @if (ic.aiResponse === 'ai運算中...') {
      <div class="ai-loading">
        <div class="loading-dots">
          <span></span><span></span><span></span>
        </div>
        <p>AI 正在解析卦象，請稍候…</p>
      </div>
      }

      @if (ic.aiResponse && ic.aiResponse !== 'ai運算中...') {
      <app-markdown
        label="AI解卦"
        name="aiResult"
        id="aiResult"
        [markdownContent]="ic.aiResponse"
        class="w-full mt-2"
      ></app-markdown>
      }

      <mat-divider class="my-4"></mat-divider>

      <app-jktextarea
        label="周易原文說明"
        [rows]="8"
        name="docResult"
        id="docResult"
        [required]="false"
        [value]="ic.document"
        [autoResizeEnabled]="true"
        [minHeight]="100"
        [maxHeight]="400"
        class="w-full"
      ></app-jktextarea>
    </div>

    <!-- 底部操作按鈕 -->
    <div class="ic-footer-actions">
      <button class="ic-btn ic-btn-ghost" (click)="prevStep()">
        ← 重新取卦
      </button>
      <div class="ic-action-group">
        <button class="ic-btn ic-btn-success" (click)="ic.doCopyClipboard()">
          📋 複製分享
        </button>
        <button class="ic-btn ic-btn-primary" (click)="nextStep()">
          記錄結果 →
        </button>
      </div>
    </div>
  </div>
  }

  <!-- ═══════════ Step 3：記錄 ═══════════ -->
  @if (ic.currentStep === 3) {
  <div class="ic-step-content">
    <div class="ic-card">
      <div class="ic-card-title">
        <span class="card-icon">📝</span> 問占記錄
      </div>
      <app-jktextarea
        label="問占結果（可手動補充）"
        [rows]="15"
        name="answerRecord"
        id="answerRecord"
        [required]="true"
        [(value)]="ic.answer"
        [autoResizeEnabled]="true"
        [minHeight]="200"
        [maxHeight]="600"
        class="w-full"
      ></app-jktextarea>
    </div>

    <!-- 底部操作按鈕 -->
    <div class="ic-footer-actions">
      <button class="ic-btn ic-btn-ghost" (click)="prevStep()">
        ← 返回結果
      </button>
      <button class="ic-btn ic-btn-primary" (click)="goToStep(0)">
        🔄 重新占卦
      </button>
    </div>
  </div>
  }

</div>
